<template>
    <div v-if="Object.keys(packet).length > 0">
        <TRItemsListV1 :viewdata="{packet: packet, params: request_parameters}"></TRItemsListV1>
    </div>
</template>
<script>
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import TRItemsListV1 from "@/components/importables/TRItemsListV1"

    export default {
        name: "ShippingCustomerPickup",
        props: [],
        components: {Backer, TRItemsListV1},
        data: function(){
            return {
                packet: {},
                //this is where you can play
                request_parameters: {
                    data_api_path: "/api/inventory/my_transfer_requests2/",
                    title: "SHIPPING: Customer Pickup",
                    data_api_params: {
                        statuses: [],
                        userid: null,
                        userrole: null,
                        request_types: ["transfer_for_pickup"],
                        source_location_id: null,
                        name: "ShippingCustomerPickup"
                    }
                }
            }
        },
        methods: {},
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.packet.global_vars = global_vars;
            if (['admin', 'officeuser'].indexOf(this.packet.userDetails.userrole) < 0){
                let user_location = this.packet.userDetails.properties.location_id;
                this.packet.locations = this.packet.locations.filter(function(d){return d.value == user_location});
            }        
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Shipping/ShippingCustomerPickup.vue